import React from "react";
import styled, { keyframes } from "styled-components";
import cameraIcon from "../assets/lucide-scan-face.svg";
import bulbIcon from "../assets/tabler-bulb.svg";
import specsIcon from "../assets/mdi-glasses.svg";
import mobileIcon from "../assets/hugeicons-hold-phone.svg";

const slideIn = keyframes`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;

const slideOut = keyframes`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;

const ModalContainer = styled.div<{ isOpen: boolean }>`
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 24px;
  transform: ${({ isOpen }) => (isOpen ? "translateY(0)" : "translateY(100%)")};
  animation: ${({ isOpen }) => (isOpen ? slideIn : slideOut)} 0.3s forwards;
  z-index: 1001;
  text-align: left;
  color: #1f1c22;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  img {
    width: 42px;
    height: 42px;
    margin-right: 5px;
  }
`;

const Title = styled.h3`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const InstructionText = styled.p`
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: 500;

  margin-bottom: 16px;
  text-align: left;
`;

const InstructionList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 14px;
  color: #1f1c22;
`;

const InstructionItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  img {
    margin-right: 8px;
    width: 42px;
    height: 42px;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 14px;
  background-color: #1f1c22;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 20px;
`;

interface BottomInstructionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BottomInstructionModal: React.FC<BottomInstructionModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <ModalContainer isOpen={isOpen}>
      <IconWrapper>
        <img src={cameraIcon} alt="Camera Icon" />
      </IconWrapper>
      <Title>
        We will now perform a Face Scan to assess your health status
      </Title>
      <InstructionText>Make sure to...</InstructionText>
      <InstructionList>
        <InstructionItem>
          <img src={bulbIcon} alt="Bulb Icon" />
          Find an area with good lighting
        </InstructionItem>
        <InstructionItem>
          <img src={specsIcon} alt="Glasses Icon" />
          Remove any eye-wear or masks
        </InstructionItem>
        <InstructionItem>
          <img src={mobileIcon} alt="Mobile Icon" />
          Keep your face and phone steady
        </InstructionItem>
      </InstructionList>
      <Button onClick={onClose}>Start Face Scan</Button>
    </ModalContainer>
  );
};

export default BottomInstructionModal;
